import { render, staticRenderFns } from "./huzhuan.vue?vue&type=template&id=2fc6d6a0&scoped=true&"
import script from "./huzhuan.vue?vue&type=script&lang=js&"
export * from "./huzhuan.vue?vue&type=script&lang=js&"
import style0 from "./huzhuan.vue?vue&type=style&index=0&id=2fc6d6a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc6d6a0",
  null
  
)

export default component.exports